window.SubscriptionFunnel.StepEmail = {
  // Populate the email-step recap from quizData (v2 snippet only)
  populateRecap() {
    const dogName = quizData.dogName || "your pup";
    const headerDogName = document.querySelector(
      "#email-capture-header [data-dog-name]"
    );
    const recapIntroDogName = document.getElementById(
      "email-step-email-intro-dog-name"
    );
    const formIntroDogName = document.getElementById(
      "email-step-form-intro-dog-name"
    );

    if (headerDogName) {
      headerDogName.textContent = dogName;
    }

    if (recapIntroDogName) {
      recapIntroDogName.textContent = dogName;
    }

    if (formIntroDogName) {
      formIntroDogName.textContent = dogName;
    }

    if (!document.getElementById("email-step-recap")) {
      return;
    }

    const displayName = quizData.dogName || "Your Pup";
    const breed1 = (quizData.breed1 || "").trim();
    const breed2 = (quizData.breed2 || "").trim();
    const size = quizData.dogSize;
    const birthday = quizData.dogBirthday;

    document.getElementById("email-recap-card-dog-name").textContent =
      displayName;
    document.getElementById("email-recap-name").textContent =
      displayName === "Your Pup" ? "" : displayName;
    document.getElementById("email-recap-breed").textContent =
      breed1 && breed2 ? `${breed1} / ${breed2}` : breed1 || breed2;

    if (size) {
      document.getElementById("email-recap-size").textContent =
        size.charAt(0).toUpperCase() + size.slice(1);
    } else {
      document.getElementById("email-recap-size").textContent = "";
    }

    if (birthday) {
      const [month, year] = birthday.split("/");
      const monthNum = Number(month);

      if (month && year && monthNum >= 1 && monthNum <= 12) {
        const monthLabel = new Date(year, monthNum - 1).toLocaleString(
          "en-US",
          { month: "long" }
        );
        document.getElementById("email-recap-birthday").textContent =
          `${monthLabel} ${year}`;
      } else {
        document.getElementById("email-recap-birthday").textContent = birthday;
      }
    } else {
      document.getElementById("email-recap-birthday").textContent = "";
    }

    const exclusions = [
      ["allergiesChicken", "No Chicken"],
      ["allergiesTurkey", "No Turkey"],
      ["allergiesBeef", "No Beef"],
    ]
      .filter(([key]) => quizData[key] === true || quizData[key] === "true")
      .map(([, label]) => label);

    document.getElementById("email-recap-allergies").textContent =
      exclusions.length > 0 ? exclusions.join(", ") : "None";
  },

  validateEmail(email) {
    const regex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
    return regex.test(email);
  },

  // Function to handle input changes
  handleEmailInput(inputElement, errorElement) {
    inputElement.addEventListener("input", (event) => {
      let value = event.target.value.trim();

      if (value === "") {
        event.target.classList.add("text-input-component-input--error");
        event.target.setAttribute("aria-invalid", "true");
        errorElement.textContent = "Error: Required field.";
        errorElement.classList.remove("display-none");
      } else if (this.validateEmail(value)) {
        event.target.classList.remove("text-input-component-input--error");
        event.target.setAttribute("aria-invalid", "false");
        errorElement.classList.add("display-none");
      } else {
        event.target.classList.add("text-input-component-input--error");
        event.target.setAttribute("aria-invalid", "true");
        errorElement.textContent = "Error: Valid email address required.";
        errorElement.classList.remove("display-none");
      }
    });

    inputElement.addEventListener("blur", (event) => {
      if (event.target.value.trim() === "") {
        event.target.classList.add("text-input-component-input--error");
        event.target.setAttribute("aria-invalid", "true");
        errorElement.textContent = "Error: Required field.";
        errorElement.classList.remove("display-none");
      }
    });
  },

  // Function to validate before proceeding to next step
  validateEmailAndProceed() {
    const emailInput = document.getElementById("account-email");
    const errorElement = document.getElementById("account-email-error");
    const email = emailInput.value.trim();

    if (email === "") {
      // Empty email is now invalid
      errorElement.textContent = "Error: Required field.";
      errorElement.classList.remove("display-none");
      emailInput.classList.add("text-input-component-input--error");
      emailInput.setAttribute("aria-invalid", "true");
      return; // Don't proceed
    } else if (this.validateEmail(email)) {
      // Valid email
      errorElement.classList.add("display-none");
      emailInput.classList.remove("text-input-component-input--error");
      emailInput.setAttribute("aria-invalid", "false");

      // Store the email in the quizData object
      quizData.email = email;

      // Proceed to the next step (adjust the step numbers as needed)
      SubscriptionFunnel.FunnelNavigation.nextStep();
    } else {
      // Invalid email
      errorElement.classList.remove("display-none");
      emailInput.classList.remove("text-input-component-input--error");
      emailInput.setAttribute("aria-invalid", "true");
    }
  },
};

// Initialize validation on page load
document.addEventListener("DOMContentLoaded", function () {
  const emailInput = document.getElementById("account-email");
  const errorElement = document.getElementById("account-email-error");

  if (emailInput && errorElement) {
    window.SubscriptionFunnel.StepEmail.handleEmailInput(
      emailInput,
      errorElement
    );
  }
});
